import { useRouter } from 'vue-router'

/** Pop history, or replace a direct entry so Back cannot return to itself. */
export function useSafeBack(defaultFallback: string | (() => string) = '/') {
  const router = useRouter()
  return (arg?: string | Event) => {
    if (arg instanceof Event) arg.preventDefault()
    const fallback = typeof defaultFallback === 'function' ? defaultFallback() : defaultFallback
    const target = typeof arg === 'string' ? arg : fallback
    // vue-router records the previous in-app entry; null means a direct load.
    if (router.options.history.state.back) router.back()
    else router.replace(target)
  }
}
